module.exports = __webpack_public_path__ + "static/2-dbba6bc9f314a69dc0902ef869072bed.svg";